import { render, staticRenderFns } from "./AccreditedSchools.vue?vue&type=template&id=7f5f9022"
import script from "./AccreditedSchools.vue?vue&type=script&lang=js"
export * from "./AccreditedSchools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports